export const enum ActorType {
	HEALTH_PROFESSIONAL = 'health_professional_type',
	HEALTH_INSTITUTION = 'health_institution_type',
}
